import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cmd00500-result-table" }
const _hoisted_2 = { class: "full-width row q-gutter-sm" }
const _hoisted_3 = { class: "q-pt-xs" }
const _hoisted_4 = { class: "add-btn-area flex items-center filter-select" }
const _hoisted_5 = { class: "flex" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import axios from '../../common/axios-common';

import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';

const DIALOG_LEVEL = 'information';
// ダイアログのtitle
interface MDeliveryTime {
  described_number: string;
  standard_delivery_time_code: string;
  standard_delivery_time_days: string;
  standard_delivery_time_name: string;
  create_user_name: string;
  create_timestamp: string;
  update_user_name: string;
  update_timestamp: string;
}

// カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any

export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00500',
  setup(__props) {

const router = useRouter();
// 削除ボタンが押された基準納期コード
const deleteDeliveryTimeCode = ref('');
// ダイアログのdisplayFlg(表示判断)
const dialogDisplayFlg = ref(false);
// ダイアログのlevel(informationで固定)
const dialogTitle = ref('');
// ダイアログのtext(配列にすることでXSSの対策を行う)
const dialogText = ref(['']);
// ダイアログのconfirmation(trueならキャンセルボタンを表示しない)
const dialogConfFlg = ref(false);
// エラーメッセージ表示フラグ
const isMessageChip = ref(false);
// エラーメッセージ
const errMessage = ref('');
// 初期表示読み込み時「データがありません」を非表示にするためのフラグ(falseで表示)
const hideNoDataFlg = ref(true);

const columns = ref<any>([
  {
    name: 'editDelete',
    label: '',
  },
  {
    name: 'described_number',
    label: '記載No.',
    align: 'left',
    field: (row: MDeliveryTime) => row.described_number,
    sortable: true,
  },
  {
    name: 'standard_delivery_time_code',
    label: '基準納期（種別）',
    align: 'left',
    field: (row: MDeliveryTime) => row.standard_delivery_time_code,
    sortable: true,
  },
  {
    name: 'standard_delivery_time_days',
    label: '基準納期（日数）',
    align: 'left',
    field: (row: MDeliveryTime) => Number(row.standard_delivery_time_days),
    sortable: true,
  },
  {
    name: 'standard_delivery_time_name',
    label: '基準納期名称',
    align: 'left',
    field: (row: MDeliveryTime) => row.standard_delivery_time_name,
    sortable: true,
  },
  {
    name: 'create_user_name',
    label: '登録者',
    align: 'left',
    field: (row: MDeliveryTime) => row.create_user_name,
    sortable: true,
  },
  {
    name: 'create_timestamp',
    label: '登録日時',
    align: 'left',
    field: (row: MDeliveryTime) => row.create_timestamp,
    sortable: true,
    style: 'width: 170px',
  },
  {
    name: 'update_user_name',
    label: '更新者',
    align: 'left',
    field: (row: MDeliveryTime) => row.update_user_name,
    sortable: true,
  },
  {
    name: 'update_timestamp',
    label: '更新日時',
    align: 'left',
    field: (row: MDeliveryTime) => row.update_timestamp,
    sortable: true,
    style: 'width: 170px',
  },
]);

const rows = ref([
  {
    described_number: '',
    standard_delivery_time_code: '',
    standard_delivery_time_days: '',
    standard_delivery_time_name: '',
    create_user_name: '',
    create_timestamp: '',
    update_user_name: '',
    update_timestamp: '',
  },
]);

/**
 * エラー初期化
 */
const resetErrors = () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

// 納期新規登録に遷移
const registerDeliveryTime = () => {
  router.push({ name: 'deliveryTimeRegister', params: { mode: '0' } });
};

// 納期情報変更に遷移
const editDeliveryTime = (deliveryTimeCode: string) => {
  router.push({ name: 'deliveryTimeEdit', params: { mode: '1', deliveryTimeCode } });
};

// 基準納期一覧取得処理
const viewDeliveryTime = async () => {
  resetErrors();
  // Loading Start
  Loading.show();

  // 基準納期一覧を取得するController呼び出し
  await axios
    .post('/cmd005001/view')
    .then((res) => {
      const { common, deliveryTimeList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          rows.value = deliveryTimeList;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          // エラー画面へ遷移
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他のエラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
      hideNoDataFlg.value = false;
    });
};

// 削除確認ダイアログのOKボタン押下時の処理
const deleteDeliveryTime = async () => {
  resetErrors();
  // Loading Start
  Loading.show();
  // 削除する基準納期コードをformDataへ
  const formData = new FormData();
  formData.append('standard_delivery_time_code', deleteDeliveryTimeCode.value);

  // 基準納期削除処理
  await axios
    .post('/cmd005001/delete', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 削除確認ダイアログのtitleを設定
          dialogTitle.value = '削除完了';
          // 削除確認ダイアログのtextを生成
          dialogText.value = [`基準納期を削除しました。`];
          // ダイアログのボタン数判断をtrue(1つ)に
          dialogConfFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.DELETE_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              // ダイアログ表示判断をfalse(非表示)に変更
              dialogDisplayFlg.value = false;
              break;
            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他のエラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// 削除確認のダイアログを表示
const deleteConfDialog = (deliveryTimeCode: string) => {
  deleteDeliveryTimeCode.value = deliveryTimeCode;

  // 削除確認ダイアログのtitleを設定
  dialogTitle.value = '削除確認';
  // 削除確認ダイアログのtextを生成
  dialogText.value = [
    `基準納期 ${deleteDeliveryTimeCode.value} を削除します。`,
    `よろしいですか？`,
  ];
  // ダイアログのボタン数判断をfalse(2つ)に
  dialogConfFlg.value = false;
  // ダイアログ表示判断をtrue(表示)に変更
  dialogDisplayFlg.value = true;
};

// 削除完了ダイアログのOKボタン押下時の処理
const dialogComplete = async () => {
  // ダイアログ表示判断をfalse(非表示)に変更
  dialogDisplayFlg.value = false;
  // 一覧を再度表示
  viewDeliveryTime();
};

// 初期表示処理呼び出し
viewDeliveryTime();

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[3] || (_cache[3] = [
        _createTextVNode("納期一覧")
      ])),
      _: 1
    }),
    _createVNode(MessageChip, {
      display: isMessageChip.value,
      level: "E",
      message: errMessage.value
    }, null, 8, ["display", "message"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(
          'chem-table-area btn-exist table-top-button ' + (rows.value.length === 0 ? 'table-nodata' : '')
        )
      }, [
        _createVNode(_component_q_table, {
          class: "my-sticky-header-column-delivery-table",
          rows: rows.value,
          columns: columns.value,
          "row-key": "index",
          flat: "",
          dense: "",
          separator: "cell",
          "hide-no-data": hideNoDataFlg.value,
          "no-data-label": "データがありません。",
          "rows-per-page-options": [10, 20, 50, 0],
          "rows-per-page-label": "件表示",
          "pagination-label": 
            (firstRowIndex, endRowIndex, totalRowsNumber) => {
              return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
            }
          
        }, {
          "no-data": _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_q_icon, {
                size: "24px",
                name: "mdi-alert-circle-outline"
              }),
              _createElementVNode("span", _hoisted_3, _toDisplayString(message), 1)
            ])
          ]),
          top: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_q_btn, {
                icon: "mdi-plus",
                class: "add-btn",
                color: "primary",
                onClick: registerDeliveryTime
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("追加")
                ])),
                _: 1
              })
            ])
          ]),
          "header-cell-editDelete": _withCtx(() => [
            _createVNode(_component_q_th, { class: "table-btn-area delete-btn-exists" })
          ]),
          "body-cell-editDelete": _withCtx((cell) => [
            (!hideNoDataFlg.value)
              ? (_openBlock(), _createBlock(_component_q_td, {
                  key: 0,
                  class: "table-btn-area delete-btn-exists"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_q_btn, {
                        icon: "mdi-pencil",
                        color: "primary",
                        onClick: ($event: any) => (editDeliveryTime(cell.row.standard_delivery_time_code))
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode(" 編集 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_q_btn, {
                        label: "削除",
                        icon: "mdi-close",
                        class: "deletebtn",
                        color: "primary",
                        outline: "",
                        style: {"color":"var(--q-delete)"},
                        onClick: ($event: any) => (deleteConfDialog(cell.row.standard_delivery_time_code))
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          "body-cell-standard_delivery_time_days": _withCtx((cell) => [
            (!hideNoDataFlg.value)
              ? (_openBlock(), _createBlock(_component_q_td, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(cell.row.standard_delivery_time_days) + "日", 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["rows", "columns", "hide-no-data", "pagination-label"]),
        _createVNode(AlertDialog, {
          display: dialogDisplayFlg.value,
          level: DIALOG_LEVEL,
          confirmation: dialogConfFlg.value,
          title: dialogTitle.value,
          text: dialogText.value,
          onComplete: _cache[0] || (_cache[0] = ($event: any) => (dialogComplete())),
          onConfirm: _cache[1] || (_cache[1] = ($event: any) => (deleteDeliveryTime())),
          onClose: _cache[2] || (_cache[2] = ($event: any) => (dialogDisplayFlg.value = false))
        }, null, 8, ["display", "confirmation", "title", "text"])
      ], 2)
    ])
  ]))
}
}

})